import React from 'react';
import { useSelector } from 'react-redux';
import { isKzUrl } from 'utils';
import { getHost } from 'selectors';
import { KzInstore } from 'containers/instore/instore-service/components/kz-instores';
import { InstoreService, InstoreServicesList, isPoshivShtor } from '../../containers/instore';
import { SEOText } from '../../common/components';
import { useInstorePage } from './hooks';
import { PoshivShtor } from '../../containers/instore/instore-service/components';

const getChild = (host: string, categoryId: string, isStoreSelected: boolean) => {
	if (isKzUrl(host)) {
		return <KzInstore />;
	}

	if (categoryId) {
		if (isPoshivShtor(categoryId) && !isStoreSelected) {
			return <PoshivShtor />;
		}
		return <InstoreService />;
	} else {
		return <InstoreServicesList />;
	}
};

export const InstorePage = () => {
	const { categoryId, isStoreSelected } = useInstorePage();
	const host = useSelector(getHost);

	return (
		<div className="services-landings__content">
			{getChild(host, categoryId, isStoreSelected)}
			{!isKzUrl(host) && <SEOText />}
		</div>
	);
};
